import React from 'react'
import isEmpty from 'lodash/isEmpty'
import { navigate } from 'gatsby'

import FontAwesome from 'components/FontAwesome'
import Cover from './Cover'

import { StyledPost, StyledExcerpt, StyledPostTitle, StyledReadMore, StyledLeft, StyledRight } from './styles'
import PostCategories from './PostCategories'
import PostInfo from './PostInfo'

export default function PostThumbnail({
   postDate,
   slug,
   postCategories,
   postTitle,
   postAuthors,
   timeRead,
   cover,
   postExcerpt,
   isFeatured,
   widerDescription = false,
}) {
   function handleOnClickPost(e) {
      e.stopPropagation()
      navigate(slug)
   }

   return (
      <StyledPost onClick={handleOnClickPost} $isFeatured={isFeatured} $widerDescription={widerDescription}>
         <StyledLeft>
            {Array.isArray(postCategories) && <PostCategories postCategories={postCategories} />}
            <StyledPostTitle>
               <span>/</span>
               <span>{postTitle}</span>
            </StyledPostTitle>
            <PostInfo authors={postAuthors} date={postDate} timeRead={timeRead} isFeatured={isFeatured} mobile={true} />
         </StyledLeft>
         <StyledRight>
            {!!cover && <Cover {...cover} />}
            {!isEmpty(postExcerpt) && <StyledExcerpt>{postExcerpt.text}</StyledExcerpt>}
            <StyledReadMore>
               <span>Read more</span>
               <FontAwesome icon="arrowRight" />
            </StyledReadMore>
            <PostInfo
               authors={postAuthors}
               date={postDate}
               timeRead={timeRead}
               isFeatured={isFeatured}
               mobile={false}
            />
         </StyledRight>
      </StyledPost>
   )
}
